import React from 'react';

import QualifyingField from '../QualifyingField';
import RadioGroup from '../RadioGroup';

import { QualifyingRadioGroupProps } from './QualifyingRadioGroup.types';

const QualifyingRadioGroup: React.StatelessComponent<QualifyingRadioGroupProps> = ({
  ...props
}: QualifyingRadioGroupProps): JSX.Element => {
  const {
    arrayHelpers,
    name,
    options,
    onFieldChange,
    recordDisqualification,
    maxWidth,
    disqualificationMessage
  } = props;
  const isValid = arrayHelpers.form.values[name] !== undefined && arrayHelpers.form.errors[name] !== undefined;

  return (
    <QualifyingField
      errors={arrayHelpers.form.errors}
      name={name}
      isValid={!isValid}
      disqualificationMessage={disqualificationMessage}
      recordDisqualification={recordDisqualification}
    >
      <RadioGroup
        name={name}
        touched={arrayHelpers.form.errors[name] !== undefined && arrayHelpers.form.touched[name]}
        isValid={isValid}
        options={options}
        arrayHelpers={arrayHelpers}
        onFieldChange={onFieldChange}
        maxWidth={maxWidth}
      />
    </QualifyingField>
  );
};

export { QualifyingRadioGroup as default };
